<template>
  <gg-card>
    <gg-card-header>
      Campaign Tracking
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <gg-text-field
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Search"
            single-line
            hide-details
          />
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
          />
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CampaignTracking',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      headers: [
        { text: 'Campaign Code', value: 'col1' },
        { text: 'Signups', value: 'col2' },
        { text: '% of Signups', value: 'col3' },
        { text: 'Gross Clicks', value: 'col4' },
        { text: '% of Gross Clicks', value: 'col5' },
        { text: 'Gross Conversion Rate', value: 'col6' },
        { text: 'Unique Clicks', value: 'col7' },
        { text: '% of Unique Clicks', value: 'col8' },
        { text: 'Unique Conversion Rate', value: 'col9' }
      ],
      search: ''
    }
  },
  computed: mapGetters({
    loading: 'affiliates/loadingStatistics'
  })
}
</script>

<style scoped>

</style>
